// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/element/rich-text/rich-text.scss
 ** module id = 69
 ** module chunks = 0 1
 **/